import { includes } from 'ramda';
import { paramFormat } from '../constants/parameterNames';
import { typeOption } from '../constants/parameterTypes';
import { getParamValue } from '../helpers/parameter.accessors';

const description = 'Returns a new GUID in the format specified.';

const VALID_FORMATS = ['B', 'D', 'N', 'P'];

const optionalParameters = {
    [paramFormat]: {
        description: 'Format for the generated GUID. Default is D.',
        display: 'Format',
        type: typeOption,
        options: [
            {
                name: 'B - braces and dashes',
                value: 'B',
            },
            {
                name: 'D - dashes',
                value: 'D',
            },
            {
                name: 'N - none (digits only)',
                value: 'N',
            },
            {
                name: 'P - parentheses and dashes',
                value: 'P',
            },
        ],
    },
};

const FORMAT_ERROR = `/${paramFormat} must be one of the following: ${VALID_FORMATS.join(
    ', ',
)}`;

function executeAsync({ api, parameters }) {
    const format = getParamValue(parameters, paramFormat, 'D').toUpperCase();

    if (!includes(format, VALID_FORMATS)) {
        throw new Error(FORMAT_ERROR);
    }

    return api.newGuidAsync(format);
}

const GenerateGuid = {
    description,
    executeAsync,
    optionalParameters,
};

export default GenerateGuid;
